export default {
      id: "logo_beaurepare-usage",
      viewBox: "0 0 229 84",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#logo_beaurepare-usage",
      toString: function () {
        return this.url;
      }
    }